import { ValidationErrors } from 'final-form';

import { LoginProjectConfiguration } from '../../../api';
import { validateUrlLink } from '../../../utils';
import { TermsAndPoliciesField } from './types';

export const TermsAndPoliciesValidator = (values: LoginProjectConfiguration): ValidationErrors => {
  const errors: Partial<Record<TermsAndPoliciesField, string>> = {};

  if (!values.tos_url) {
    errors.tos_url = 'app.validation.required';
  } else if (values.tos_url && !validateUrlLink(values.tos_url)) {
    errors.tos_url = 'app.validation.url-invalid';
  }

  if (values.privacy_policy && !validateUrlLink(values.privacy_policy)) {
    errors.privacy_policy = 'app.validation.url-invalid';
  }

  if (values.cookie_policy && !validateUrlLink(values.cookie_policy)) {
    errors.cookie_policy = 'app.validation.url-invalid';
  }

  return errors;
};
